import React, { Component } from "react";
import "./Categories.scss";
import { connect } from "react-redux";
import 'react-widgets/dist/css/react-widgets.css'
import "../MainContent.scss";
import BootstrapTable from 'react-bootstrap-table-next';
import {
	getSubcategoriesPag, getSubcategoriesToSelect,
	createSubcategories, updateSubcategories, deactivateSubcategories,
	activateSubcategories
} from "../../../../actions/SubcategoriesActions";
import {
	CREATE_SUBCATEGORIES, UPDATE_SUBCATEGORIES, GET_ERRORS,
	DEACTIVATE_SUBCATEGORIES, ACTIVATE_SUBCATEGORIES
} from "../../../../actions/types";
import DetailModal from "./DetailModal";
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const modalButtonPager = {
	marginRight: "1%",
	marginBottom: "1%",
	backgroundColor: "#39A2DB",
	color: "#E8F0F2"
}
const modalButtonPagerDisabled = {
	marginRight: "1%",
	marginBottom: "1%",
	backgroundColor: "#39A2DB",
	color: "#E8F0F2",
	opacity: 0.5
}


class SubcategoriesContent extends Component {

	///---------------------------------------INIT-------------------------------------

	state = {
		activeLoader: true,
		subcategories: [],
		showSnackBar: false,
		textSnackBar: '',
		severitySnackBar: 'success',
		openDetailModal: false,
		showDeactivateDialog: false,
		selectedId: 0,

		skip: 1,
		data: {
			_id: null,
			name: null,
			image_url: null,
			subcategories: [],
			is_active: null
		},
		search: ""
	}

	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.openModal = this.openModal.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onPressCancel = this.onPressCancel.bind(this);
		this.onPressDelete = this.onPressDelete.bind(this);
		this.onActivate = this.onActivate.bind(this);
		this.onDeactivate = this.onDeactivate.bind(this);
	}

	componentDidMount() {
		this.props.getSubcategoriesPag(1);
	}

	componentDidUpdate(prevProps) {

		if (this.state.subcategories !== this.props.subcategories || this.props.subcategories.length === 0) {
			this.setState({
				activeLoader: false,
				subcategories: this.props.subcategories
			});
		}
		else if (this.props.actionType === ACTIVATE_SUBCATEGORIES && prevProps.actionType !== ACTIVATE_SUBCATEGORIES) {
			this.props.getSubcategoriesPag(this.state.skip);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Subcategoría activada exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === DEACTIVATE_SUBCATEGORIES && prevProps.actionType !== DEACTIVATE_SUBCATEGORIES) {
			this.props.getSubcategoriesPag(this.state.skip);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Subcategoría desactivada exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === UPDATE_SUBCATEGORIES && prevProps.actionType !== UPDATE_SUBCATEGORIES) {
			this.props.getSubcategoriesPag(this.state.skip);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Subcategoría actualizada exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === CREATE_SUBCATEGORIES && prevProps.actionType !== CREATE_SUBCATEGORIES) {
			this.props.getSubcategoriesPag(this.state.skip);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Subcategoría creada exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			showSnackBar: false
		})
	};

	handleCloseDeactivateDialog = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showDeactivateDialog: false
		})
	};

	onChange(e) {
		e.persist();
		this.setState({
			[e.target.name]: e.target.value
		}, () => this.props.getSubcategoriesPag(1, this.state[e.target.name]))
	}

	onSave(data) {
		if (data._id !== null)
			this.onUpdate(data);
		else
			this.handleOk(data);
	}

	async onUpdate(data) {
		let img_b64 = null;
		let extension = null;
		let subcategories = [];
		if (data.newImage) {
			img_b64 = data.file;
			extension = data.extension;
		}
		if (data.subcategories.length > 0)
			subcategories = data.subcategories.map((subcategory) => subcategory._id);
		this.props.updateSubcategories(data._id, data.name, img_b64, extension, subcategories);
		this.setState({
			activeLoader: true,
			openDetailModal: false,
			data: {
				_id: null,
				name: null,
				image_url: null,
				subcategories: [],
				is_active: null
			},
		})
	}

	async handleOk(data) {
		let img_b64 = null;
		let extension = null;
		let subcategories = [];
		if (data.newImage) {
			img_b64 = data.file;
			extension = data.extension;
		}
		if (data.subcategories.length > 0)
			subcategories = data.subcategories.map((subcategory) => subcategory._id);
		this.props.createSubcategories(data.name, img_b64, extension, subcategories);
		this.setState({
			activeLoader: true,
			openDetailModal: false,
			data: {
				_id: null,
				name: null,
				image_url: null,
				subcategories: [],
				is_active: null
			},
		})
	}

	onPressCancel() {
		this.setState({
			openDetailModal: false,
			data: {
				_id: null,
				name: null,
				image_url: null,
				subcategories: [],
				is_active: null
			},
		})
	}

	onPressDelete(id) {
		this.setState({
			showDeactivateDialog: true,
			selectedId: id,
		})
	}

	onDeactivate() {
		this.setState({
			activeLoader: true,
			openDetailModal: false,
			showDeactivateDialog: false
		});
		this.props.deactivateSubcategories(this.state.selectedId);
	}

	onActivate(id) {
		this.setState({
			activeLoader: true,
			openDetailModal: false
		});
		this.props.activateSubcategories(id);
	}

	openModal(row) {
		if (!row.dispatchConfig) {
			let data = {
				_id: row._id,
				name: row.name,
				image_url: row.image_url,
				subcategories: row.subcategories.map((subcategory) => {
					return {
						_id: subcategory._id,
						name: subcategory.name
					}
				}),
				is_active: row.is_active
			}
			this.setState({
				openDetailModal: true,
				data: data
			})
		}
		else
			this.setState({
				openDetailModal: true,
				data: {
					_id: null,
					name: null,
					image_url: null,
					subcategories: [],
					is_active: null
				},
			})
	}

	///---------------------------------------VIEW-------------------------------------

	renderTable(subcategories) {
		const columns = [
			{
				dataField: 'image_url',
				text: 'Imagen',
				formatter: (cell) => {
					return <img
						src={cell}
						width="30%"
						alt={"Sin imagen"}
					/>
				}
			},
			{
				dataField: 'name',
				text: 'Nombre',
				headerStyle: () => {
					return { width: "30%" };
				},
			},
			{
				dataField: 'subcategories',
				text: 'Subcategorías',
				headerStyle: () => {
					return { width: "40%" };
				},
				formatter: (cell) => {
					if (cell)
						return <>{cell.map((label, index) => <li key={index}>{label.name}</li>)}</>
					else
						return ""
				},
			},
			{
				dataField: 'is_active',
				text: 'Estatus',
				headerStyle: () => {
					return { width: "10%" };
				},
				formatter: (cell) => cell ? "Activa" : "Inactiva",
			}
		];
		const rowEvents = {
			onClick: (e, row, rowIndex) => {
				this.openModal(row);
			}
		};

		const total = this.props.subcategoriesToSelect.length
		const totalPages = total / 6

		return (
			<center>
				<div className="toolbar space">
					<TextField
						style={{ height: "10%", width: "49.8%" }}
						id="input-search"
						label="BUSCAR"
						name="search"
						inputProps={{ style: { fontSize: "1rem" } }}
						InputLabelProps={{ style: { fontSize: "0.7rem" } }}
						onChange={this.onChange}
						value={this.state.search}
						size="medium"
					/>
					<Button
						style={{
							height: "10%",
							backgroundColor: "#2ecc71",
							padding: "0.8rem 0.8rem",
							fontSize: "0.7rem"
						}}
						variant="contained"
						color="primary"
						startIcon={<Icon>add</Icon>}
						onClick={this.openModal}
					>
						Agregar
					</Button>
				</div>
				<center>
					<div style={{ textAlign: "left", height: "55vh", overflow: "auto", width: "100%", marginBottom: "1vh" }}>
						{
							<BootstrapTable keyField='_id'
								key="8908290138209"
								striped
								hover
								condensed
								rowEvents={rowEvents}
								data={subcategories}
								headerWrapperClasses="title-table"
								rowClasses="custom-row-table table-hover"
								columns={columns}
							/>
						}
					</div>
				</center>
				<div className="toolbar100 end">
					<Button
						style={this.state.skip !== 1 ? modalButtonPager : modalButtonPagerDisabled}
						onMouseDown={(e) => {
							e.preventDefault();
							this.setState({
								skip: this.state.skip - 1
							}, () => {
								this.props.getSubcategoriesPag(this.state.skip);
							})

						}}
						disabled={this.state.skip === 1 ? true : false}
					>
						<span style={{ fontSize: "8px" }}>« Anterior</span>
					</Button>
					<Button
						style={this.state.skip < totalPages ? modalButtonPager : modalButtonPagerDisabled}
						href=""
						onMouseDown={(e) => {
							e.preventDefault();
							this.setState({
								skip: this.state.skip + 1
							}, () => {
								this.props.getSubcategoriesPag(this.state.skip);
							})
						}}
						disabled={this.state.skip < totalPages ? false : true}
					>
						<span style={{ fontSize: "8px" }}>Siguiente »</span>
					</Button>
				</div>
			</center>
		);
	}

	render() {

		return (
			<div>
				{
					<DetailModal
						isVisible={this.state.openDetailModal}
						data={this.state.data}
						subcategoriesToSelect={this.props.subcategoriesToSelect}
						onSave={this.onSave}
						onPressCancel={this.onPressCancel}
						onPressDelete={this.onPressDelete}
						onPressActivate={this.onActivate}
						type="subcategory"
					/>
				}
				{
					this.renderTable(this.state.subcategories)
				}
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}

				{
					<Dialog
						open={this.state.showDeactivateDialog}
						onClose={this.handleCloseDeactivateDialog}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Desactivar subcategoria"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								¿Seguro que deseas desactivar la subcategoria?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleCloseDeactivateDialog} color="secondary">
								Cancelar
							</Button>
							<Button onClick={this.onDeactivate} color="primary" autoFocus>
								Desactivar
							</Button>
						</DialogActions>
					</Dialog>
				}
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}

			</div>
		)

	}
}

const mapStateToProps = state => ({
	error: state.subcategory_reducer.error,
	subcategories: state.subcategory_reducer.subcategoriespag,
	actionType: state.subcategory_reducer.actionType
});

export default connect(
	mapStateToProps,
	{
		getSubcategoriesPag,
		getSubcategoriesToSelect,
		createSubcategories,
		updateSubcategories,
		deactivateSubcategories,
		activateSubcategories
	}
)(SubcategoriesContent);